import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'periscope.open-pr-widget.title-non-final',
		defaultMessage: 'Open pull requests (last 30 days)',
		description:
			'The title for the Open pull requests (last 30 days) widget on the Development page.',
	},
});
